import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { BehaviorSubject } from 'rxjs'
import { WorkSchedule } from '../work-schedule'
import { AsyncPipe } from '@angular/common'
import { WorkScheduleEditComponent } from '../work-schedule-edit/work-schedule-edit.component'

@Component({
  selector: 'app-work-schedule-detail',
  templateUrl: './work-schedule-detail.component.html',
  styleUrls: ['./work-schedule-detail.component.scss'],
  imports: [WorkScheduleEditComponent, AsyncPipe],
})
export class WorkScheduleDetailComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  public readonly schedule$ = new BehaviorSubject<WorkSchedule>(null)

  @Output()
  public scheduleChange: EventEmitter<WorkSchedule> = new EventEmitter<WorkSchedule>()

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set schedule(schedule: WorkSchedule) {
    this.schedule$.next(schedule)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onScheduleChange(schedule: WorkSchedule): void {
    this.scheduleChange.emit(schedule)
  }
}
